export default class CampaignsController {
    constructor($scope, $state, $ionicLoading, ApiCampaigns, $ionicScrollDelegate, $stateParams) {
        this.ApiCampaigns = ApiCampaigns;
        this.$ionicLoading = $ionicLoading;
        this.$state = $state;
        this.campaigns = [];
        this.loading = [];
        this.campaignType = $stateParams.campaignType;
        this.$ionicScrollDelegate = $ionicScrollDelegate;
    }

    init() {

    }

    showLoading() {
        this.loading.push(1);
        this.$ionicLoading.show({
            template: '<spinner-advinda></spinner-advinda>'
        });
    }

    hideLoading() {
        this.loading.pop();
        if (this.loading.length === 0)
            this.$ionicLoading.hide();
    }

    removeCampaign(campaign) {
        this.ApiCampaigns.deleteCampaign(campaign.campaignId).then((res) => {
            if (res) {
                this.campaigns.splice(this.campaigns.indexOf(campaign), 1);
            }
        });
    }

    redirectToCampaignCreatePageBasedOnType() {
        // ui-sref="campaignAdd({type:'children'})"
        if (this.campaignType == 'MOTHER_CAMPAIGN'){
            this.$state.go('motherCampaignAdd');
        } else {
            this.$state.go('campaignAdd', { type: 'children' });
        }
    }

    onTypeChanged(campaignType) {
        this.campaignType = campaignType;
    }

    onTabChange(type) {
        this.campaignType = type;
        this.$ionicScrollDelegate.scrollTop();
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/components/campaigns/campaigns.controller.js
 **/